<template>
  <div class="page-content znjcQsfx" :style="defaultHeight">
    <div class="startTitle">微体检-{{znjcTit}}-趋势分析</div>
    <el-row class="lineH">
      <el-col :span="12" class="znjc_tit">
        <img :src="znjcTitImg" alt="">
        <span>{{znjcTit}}</span>
      </el-col>
      <el-col :span="12" class="textR">
        <el-button type="info" class="seeqsfxBtn" @click="totablePage()">监测列表</el-button>
      </el-col>
    </el-row>
    <el-row class="borBttomCold">
      <el-col :span="12" class="textR">
        <div class="numUnitBox">
          <span class="lasttit">最新{{znjcTit}}数据</span>
          <div class="numUnit" v-if="line_series.length<2"><span class="numText">{{line_series[0].data[line_series.length-1]}}</span><span class="unitText">{{unit}}</span></div>
          <div class="numUnit" v-if="line_series.length>1"><span class="numText">{{line_series[0].data[line_series[0].data.length-1]}}/{{line_series[1].data[line_series[1].data.length-1]}}</span><span class="unitText">{{unit}}</span></div>
          <span class="jcTime" v-for="(val,index) in line_time" v-if="index==line_time.length-1">监测时间：{{val}}</span>
        </div>
      </el-col>
      <el-col :span="12" class="textL">
        <div class="numUnitBox" style="border-right: none;">
          <div id="yuan" style="width: 400px;height: 120px;padding-left: 68px;"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="padding-top: 45px;">
        <div id="qx" style="width:100%;height:350px;"></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import '@/assets/css/backcommon.css'
import echarts from 'echarts'
const animationDuration = 6000
// require('echarts/theme/macarons') // echarts theme
import { znjcIndexObj } from "@/api/znjcIndex";
import { userDataReportChart } from "@/api/dataReport";
export default {
  name: "znjcQsfx",
  data() {
    return {
      id: this.$router.currentRoute.query.id,
      unit: this.$router.currentRoute.query.unit,
      defaultHeight: {
        height: ""
      },
      chart_yuan: null,
      chart_qx: null,
      yuan_data: [],
      yuan_qx: [],
      znjcTit: this.$router.currentRoute.query.name,
      znjcTitImg: this.$router.currentRoute.query.img,
      line_series: "",
      line_name: "",
      line_time: "",
      pic_series: "",
      pic_name: ""
    }
  },
  components: {},
  methods: {
    //定义方法，获取高度减去头尾

    getHeight() {
      this.defaultHeight.height = window.innerHeight + "px";
    },
    totablePage() {
      this.$router.back(-1);
    },
    initChart_yuan(title, legend, data) {
      var ths = this;
      this.chart_yuan = echarts.init(document.getElementById("yuan"), 'macarons');
      this.chart_yuan.setOption({
        title: {
          text: title,
          x: '48%', //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
          y: '11%',
          textStyle: {
            color: '#000000', //颜色
            fontWeight: '600', //粗细
            fontSize: 16, //大小
            align: 'center' //水平对齐
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        color: ["#5B95FF", "#FF7F7B"],
        legend: {
          selectedMode: false,
          orient: 'vertical',
          icon: "circle",
          left: "50%",
          top: 50,
          bottom: 20,
          data: legend,
          formatter: function(obj) {
            console.log(obj);
            var pic_series = ths.pic_series;
            console.log(pic_series);
            for (var i = 0; i < pic_series.length; i++) {
              var item = pic_series[i];
              if (item.name == obj) {
                return '{a|' + obj + '}' + "       " + '{b|' + item.proportion + '}'
              }
            }

          },
          textStyle: {
            rich: {
              a: {
                fontSize: 14,
                color: '#656565',
              },
              b: {
                fontSize: 14,
                color: '#000000',
              }
            }
          },
        },
        series: [{
          silent: true, //关键句
          name: '访问来源',
          type: 'pie',
          radius: ['65%', '100%'],
          center: ['20%', '50%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: false,
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }]
      })
    },
    initChart_qx(title, legend, xdata, ydata) {
      var dataZoom = [{
        start: 0, //默认为0
        end: 30, //默认为100
        type: 'slider',
        show: true,
        xAxisIndex: [0],
        handleSize: 0, //滑动条的 左右2个滑动条的大小
        height: 5, //组件高度
        left: '5%', //左边的距离
        right: '1%', //右边的距离
        bottom: 26, //右边的距离
        borderColor: "#F0ECF8",
        fillerColor: '#14C86CFF',
        borderRadius: 5,
        backgroundColor: "#F0ECF8", //两边未选中的滑动条区域的颜色
        showDataShadow: false, //是否显示数据阴影 默认auto
        showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
        realtime: true, //是否实时更新
        filterMode: 'filter',


      }];
      this.chart_qx = echarts.init(document.getElementById("qx"), 'macarons');
      this.chart_qx.setOption({
        title: {
          text: title,
          x: 'left', //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
          y: 'top',
          textStyle: {
            color: '#000000', //颜色
            fontWeight: '600', //粗细
            fontSize: 16, //大小
            align: 'center' //水平对齐
          }
        },
        dataZoom: xdata.length <= 6 ? "" : dataZoom,
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legend,
          // icon: "circle",
          left: "20%",
          itemGap: 50
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '1%',
          containLabel: true
        },
        color: ['#FF9307', '#5BAF21'],
        xAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#656565',
              fontSize: "12",
              padding: [20, 0, 0, 0]
            }
          },
          offset: [4],
          axisTick: { show: false },
          axisLine: { show: false },

          type: 'category',
          boundaryGap: false,

          data: xdata
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#1B2D32',
              fontSize: "13",
              padding: [0, 10, 0, 0]
            }
          },

          axisTick: { show: false },
          axisLine: { show: false },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#E5E5E5'],
              width: 1,
              type: 'solid'
            }
          },
          splitArea: { show: false } //保留网格区域
        },
        series: ydata
      })
    },
    initChart() {
      this.$nextTick(() => {
        this.initChart_yuan(
          this.znjcTit + '预警占比',
          this.pic_name,
          this.pic_series
        );
        this.initChart_qx(
          this.znjcTit + '监测趋势',
          this.line_name,
          this.line_time,
          this.line_series
        );
      });
    },
    userDataReportChart() {
      var ths = this;
      var params = { "reportType": this.id };
      userDataReportChart(params).then(res => {
        console.log(res.data);
        if (parseInt(res.data.code) === 200) {
          ths.line_series = res.data.line.series;
          ths.line_name = res.data.line.name;
          ths.line_time = res.data.line.time;
          ths.pic_series = res.data.pic.series;
          ths.pic_name = res.data.pic.name;
          ths.initChart();
        }
      });
    }

  },
  beforeDestroy() {
    if (!this.chart_yuan) {
      return
    }
    this.chart_yuan.dispose();
    this.chart_yuan = null;
    if (!this.chart_qx) {
      return
    }
    this.chart_qx.dispose();
    this.chart_qx = null;
  },
  mounted() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.userDataReportChart();

  }
}

</script>
<style scoped>
.lineH {
  /*line-height: 60px;*/
  padding-top: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid #EDEDED;
}

.znjc_tit img {
  position: relative;
  /* top: 10px; */
  left: 10px;
  width: 40px;
  height: 40px;
  display: inline-block;
}

.znjc_tit span {
  margin-left: 15px;
  display: inline-block;
  font-size: 28px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.textR {
  text-align: right;
}

.textL {
  text-align: left;
}

.seeqsfxBtn {
  margin-right: 20px;
  background-color: #59677F;
  border-radius: 3px;
}

.znjcQsfx .numUnitBox {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 370px;
  text-align: center;
  display: inline-block;
  border-right: 1px solid #E5E5E5FF;
}

.znjcQsfx .lasttit {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: rgba(101, 101, 101, 1);
  margin-bottom: 15px;
}

.znjcQsfx .numUnit {
  /*line-height: 46px;*/
  margin-bottom: 15px;
}

.znjcQsfx .numUnit .numText {
  font-size: 30px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-right: 30px;
}

.znjcQsfx .numUnit .unitText {
  font-size: 16px;
  font-weight: 400;
  color: rgba(101, 101, 101, 1);
  display: inline-block;
}

.znjcQsfx .numUnitBox .jcTime {
  font-size: 14px;
  font-weight: 400;
  color: rgba(101, 101, 101, 1);
  display: inline-block;
}

.borBttomCold {
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 7px solid #F3F5F7FF;
}

</style>



// WEBPACK FOOTER //
// src/views/personCenter/znjcQsfx.vue